export default {
  "pl": {
    "document": {
      "actions": {
        "delete": "Usuń",
        "deleteMultipleDocuments": "Usuń…",
        "delete_cancel": "Anuluj",
        "delete_documents": "Usuń dokument | Usuń dokumenty",
        "download": "Pobierz",
        "edit": "Edytuj",
        "hideDetails": "Ukryj szczegóły",
        "new": "Prześlij dokumenty",
        "share": "Dzielić",
        "shareWithProjectPartners": "Udostępnij/cofnij udostępnianie partnerom projektu...",
        "share_documents": "Udostępnij dokument | Udostępnij dokumenty",
        "share_with": "Udostępnij…",
        "showDetails": "Pokaż szczegóły",
        "submit": "Prześlij",
        "tickBoxesDeletion": "Zaznacz pola wyboru przy plikach, które chcesz usunąć.",
        "unshare": "Cofnij udostępnianie",
        "unshare_documents": "Cofnij udostępnianie dokumentu | Cofnij udostępnianie dokumentów"
      },
      "attachable_types": {
        "building": "Budynek",
        "decisions": "Decyzje",
        "installment": "Rata",
        "issue": "Problem",
        "lot": "Działka",
        "phase": "Faza",
        "project": "Projekt",
        "tickets": "Rozmowy",
        "unit": "Jednostka"
      },
      "attributes": {
        "category": "Kategoria",
        "file_ext": "Typ pliku",
        "file_size": "Rozmiar pliku",
        "name": "Nazwa",
        "uploaded_at": "Przesłany dnia",
        "uploaded_by": "Przesłany przez:"
      },
      "category": {
        "admin": "Plik administracyjny",
        "as_built": "Plik powykonawczy",
        "brochure": "Broszura",
        "decision": "Decyzja",
        "image": "Obraz",
        "invoice": "Faktura",
        "legal": "Dokument prawny",
        "manual": "Instrukcja",
        "other": "Inny",
        "plan": "Plan",
        "quote": "Wycena",
        "ticket": "Rozmowa"
      },
      "labels": {
        "allDocuments": "Wszystkie dokumenty",
        "allUnits": "Wszystkie jednostki",
        "building": "budynek",
        "categories": "Kategorie",
        "created": "Utworzony dnia",
        "customer": "Klient",
        "decision": "decyzja",
        "decisionsAndProposals": "Decyzje i Propozycje",
        "disclaimerDocumentsCustomer": "Znajdź lub prześlij dokumenty związane z decyzją: {decision_name}",
        "documents": "Dokumenty",
        "documents_all": "Wszystkie dokumenty",
        "documents_plan": "Dokumenty zawierające plany",
        "documents_plan_explainer": "Dokumenty umieszczone w folderze z dokumentami jednostki {unit_name} w kategorii Plan będą automatycznie dodawane do tej decyzji i udostępniane wszystkim partnerom. ",
        "editDocument": "Edytuj dokument",
        "files": "Pliki związane z: {level_name}",
        "filter": "Filtr",
        "folders": "Foldery",
        "goToUnitDocumentsFolder": "Przejdź do folderu z dokumentami jednostki: {unit_name}",
        "goToUnitsFolder": "Ta strona zawiera tylko dokumenty związane z decyzjami. Aby wyświetlić inne dokumenty, przejdź do folderu jednostki.",
        "include_original_documents": "Dołącz oryginalne dokumenty",
        "includesProposalAndDocuments": "Obejmuje dokumenty ofertowe i dokumenty decyzyjne",
        "info": "Wkrótce znajdziesz tu dokumenty związane z twoim domem.",
        "locked": "Ten dokument znajduje się w kategorii Plan i może zostać usunięty wyłącznie z poziomu folderu z dokumentami jednostki",
        "lockedDocumentApprovedProposal": "Ten dokument należy do zatwierdzonego wniosku i nie można go usunąć",
        "lockedDocumentDelete": "Tego dokumentu nie można usunąć",
        "lot": "działka",
        "more_info": "Więcej informacji",
        "name_asc": "Nazwa A->Z",
        "name_desc": "Nazwa Z->A",
        "noCustomer": "Nie przypisano jeszcze żadnego klienta",
        "noPreviewPossible": "Nie można wyświetlić podglądu dokumentów tego typu. Spróbuj najpierw pobrać plik.",
        "no_plan_documents": "Nie dodano żadnych planów do folderu jednostki",
        "onlyUnitDocumentsSharedWithProjectPartners": "Partnerom projektu można udostępnić tylko dokumenty jednostek",
        "only_approved_proposals": "Wyświetlane są tylko dokumenty z zatwierdzonych propozycji",
        "original_documents_info": "Pokaż oryginały dokumentów podpisanych.",
        "owner": "Właściciel",
        "phase": "faza",
        "project": "projekt",
        "project_partners": "Partnerzy projektu",
        "proposal": "oferta",
        "search_document": "Wyszukaj dokument",
        "shareWith": "Udostępnij:",
        "sharedWithClient": "Udostępniono {client_name}",
        "sharedWithProjectPartners": "Udostępniono partnerom projektu",
        "shared_with": "Współdzielone z",
        "sharingSettingsDecision": "W tej decyzji",
        "sharingSettingsProject": "W tym projekcie",
        "showDocumentsFor": "Pokaż dokumenty jednostki:",
        "showLevel": "To jest dokument związany z: {level}",
        "signed": "Podpisany",
        "signedBy": "Podpisany przez:",
        "source": "Źródło",
        "subtitleSharingDocuments": "Wybrany dokument będzie dostępny dla Partnerów Projektu | Wybrane dokumenty będą dostępne dla Partnerów Projektu",
        "subtitleUnsharingDocuments": "Wybrany dokument nie będzie dostępny dla Partnerów Projektu | Wybrane dokumenty nie będą dostępne dla Partnerów Projektu",
        "ticket": "rozmowa",
        "unit": "jednostka",
        "unitFolder": "Dokumenty jednostki",
        "updated_at_asc": "Najpierw najstarsi",
        "updated_at_desc": "Najnowszy jako pierwszy",
        "upload_failed": "Nie udało się przesłać 1 lub więcej plików. Usuń je lub spróbuj przesłać ponownie.",
        "uploadedBy": "Przesłany przez:",
        "visibleFor": "Udostępniono:",
        "warningNotShared": "Ups! Nikogo nie wybrano. Czy tak miało być? Kliknij ponownie, aby potwierdzić."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Kiedy nowy dokument stanie się dostępny, otrzymasz powiadomienie e-mail. W tym miejscu będzie można go wyświetlić i pobrać.",
            "title": "Tu znajdziesz wszystkie swoje dokumenty"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Kiedy prześlesz dokument, wszyscy związani z nim klienci otrzymają powiadomienie e-mail.",
            "title": "Brak dokumentów związanych z: {level_name}"
          }
        },
        "partners": {
          "navigate": {
            "subtitle": "Poruszaj się po strukturze projektu, aby zobaczyć dokumenty jednostki",
            "title": "Idź do jednostki, aby zobaczyć dokumenty"
          },
          "new": {
            "subtitle": "Kiedy prześlesz dokument, wszyscy związani z nim klienci otrzymają powiadomienie e-mail.",
            "title": "Brak dokumentów związanych z tą decyzją"
          },
          "none": {
            "subtitle": "Tu znajdziesz dokumenty związane z: {unit}",
            "title": "Brak dokumentów"
          }
        }
      },
      "toasts": {
        "bulk_delete": "Dokument został usunięty | Dokumenty zostały usunięte",
        "bulk_upload": "Dokument został przesłany | Dokumenty zostały przesłane",
        "update": "{count} dokument został pomyślnie zaktualizowany | Pomyślnie zaktualizowano {count} dokumentów",
        "upload_success": "Przesłano {count} dokument | Przesłano następującą liczbę dokumentów: {count}"
      },
      "validation": {
        "need_category": "Wymagana kategoria",
        "need_category_all": "Wszystkie dokumenty muszą mieć kategorię",
        "selectDocument": "Wybierz przynajmniej 1 dokument"
      }
    }
  }
}
